import { render, staticRenderFns } from "./PhysicalPurchasesList.vue?vue&type=template&id=ee55b99c"
import script from "./PhysicalPurchasesList.vue?vue&type=script&lang=js"
export * from "./PhysicalPurchasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports